import { EvaCompanyService } from "src/app/features/eva-company/services/evaCompany.service";

import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";

@Injectable({ providedIn: "root" })
export class AdminGuard {
  constructor(
    private evaCompanyService: EvaCompanyService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.evaCompanyService.hasAdminRights()) return true;
    this.router.navigate(["/home"]);
    return false;
  }
}
